import React from 'react';
import { FaVolumeMute, FaVolumeUp } from 'react-icons/fa';

interface AudioControlProps {
  isPlaying: boolean;
  onToggle: () => void;
}

export const AudioControl: React.FC<AudioControlProps> = ({ isPlaying, onToggle }) => (
  <button onClick={onToggle} className="p-2 hover:bg-gray-100 rounded-full">
    {isPlaying ? <FaVolumeMute /> : <FaVolumeUp />}
  </button>
);